<template>
  <el-card>
    <SweetTable :is-page="false" ref="table" url="/erp/settle/material/factory/list" :query-form="dataForm"
                :before-table-binding="beforeTableBinding" :row-style="rowStyleHandler"
                :summariesColumn="['totalAmount','useCount','limitCount','productSendCount']" :height="500">
      <el-table-column
          prop="companyName"
          label="工厂名称"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="materialInfo.name"
          label="品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="materialInfo.color"
          label="颜色"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="materialInfo.size"
          label="规格"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="materialInfo.attr1"
          label="幅宽"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="materialInfo.attr2"
          label="克重"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column prop="receiveCount" label="收货数量" header-align="center" align="center">
        <template #default="{row}">
          <el-button type="text" @click="showMaterialReceiveList(row)">{{row.receiveCount}}</el-button>
        </template>
      </el-table-column>
      <el-table-column
          prop="price"
          label="开票单价"
          header-align="center"
          align="center"
      >
      </el-table-column>
      <el-table-column
          label="金额"
          header-align="center"
          align="center"
          prop="totalAmount"
      >
      </el-table-column>
      <el-table-column
          prop="useCount"
          label="用料数量"
          header-align="center"
          align="center"
      >
        <template #default="{row}">
          <el-button type="text" @click="showMaterialUseList(row)">{{row.useCount}}</el-button>
        </template>
      </el-table-column>
      <el-table-column
          prop="limitCount"
          label="库存数量"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="bomCount"
          label="单耗"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
    </SweetTable>
    <MaterialUseList ref="MaterialUseList"></MaterialUseList>
    <MaterialReceiveList ref="MaterialReceiveList"></MaterialReceiveList>
  </el-card>
</template>

<script>
import BigNumber from 'bignumber.js'
import SettleReportMixin from '@/views/modules/settle/report/SettleReportMixin'
import MaterialUseList from '@/views/modules/settle/report/material-use-list.vue'
import MaterialReceiveList from '@/views/modules/settle/report/material-receive-list.vue'
export default {
  name: 'FactoryMaterial',
  mixins: [SettleReportMixin],
  props: {
    orderId: ''
  },
  components: { MaterialUseList ,MaterialReceiveList},
  data () {
    return {
      maxTableHeight: 500,
      dataForm: {
        orderId: ''
      }
    }
  },
  watch: {
    orderId: {
      handler: function (newVal) {
        if (!newVal) {
          this.$refs.table.dataList = []
          return
        }
        this.dataForm.orderId = newVal
        this.$nextTick(() => {
          this.reload()
        })
      },
      immediate: true
    }
  },
  methods: {
    rowStyleHandler({ row, rowIndex }) {
      let rowStyle={};
      if(row.isWarning===1){
        rowStyle= {
          color:'red'
        }
      }
      return rowStyle;
    },
    showMaterialReceiveList(row){
      this.$refs.MaterialReceiveList.materialInfo=row.materialInfo
      this.$refs.MaterialReceiveList.init(row.companyId, row.materialId, row.orderId)
    },
    showMaterialUseList (row) {
      this.$refs.MaterialUseList.materialInfo=row.materialInfo
      this.$refs.MaterialUseList.init(row.companyId, row.materialId, row.orderId)
    },
    reload () {
      // this.$refs.table.reload()
      this.$refs.table.reload()
    },
    // beforeTableBinding (dataList) {
    //   dataList.forEach(row => {
    //     if (!row.receiveCount) {
    //       row.receiveCount = 0
    //     }
    //     if (!row.productSendCount) {
    //       row.productSendCount = 0
    //     }
    //     if (!row.bomCount) {
    //       row.bomCount = 0
    //     }
    //     row.bomCount = new BigNumber(row.bomCount).toFixed(3)
    //     let useCount = new BigNumber(row.useCount)
    //     row.limitCount = new BigNumber(row.receiveCount || 0).minus(useCount).toFixed(2)
    //     row.totalAmount = new BigNumber(row.receiveCount).multipliedBy(row.price || 0).toFixed(2)
    //   })
    // },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        console.log(row.receiveCount)
        if (!row.receiveCount) {
          row.receiveCount = 0
        }
        row.limitCount = new BigNumber(row.receiveCount ).minus(row.useCount).toFixed(5)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.count-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
}
</style>
